import React from "react";
import { makeStyles, Typography, Link as MuiLink } from "@material-ui/core";
import Link from "next/link";

import Arrow from "../assets/arrow.svg";
import LogoMurfy from "components/header/assets/logo-murfy.svg";

export default function NewPassword() {
  const classes = useStyle();
  return (
    <div className={classes.container}>
      <Link href="/reconditionne" passHref>
        <MuiLink underline="none" className={classes.link}>
          <LogoMurfy className={classes.logo} />
        </MuiLink>
      </Link>
      <Typography variant="h1" className={classes.title}>
        Un tour et ça répare
      </Typography>
      <Arrow className={classes.arrow} />
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  link: {
    position: "absolute",
    left: 40,
    top: 40,
  },
  logo: {
    width: 80,
    fill: theme.palette.yellow,
    transition: "400ms",
    "&:hover": {
      cursor: "pointer",
      transform: "rotate(360deg)",
      transition: "1000ms",
    },
  },
  title: {
    fontWeight: 900,
    fontSize: 44,
    lineHeight: "50px",
    textAlign: "center",
    maxWidth: 300,
    color: theme.palette.yellow,
    marginBottom: theme.spacing(5),
  },
  container: {
    position: "relative",
    width: "30%",
    backgroundImage: "url('/reconditionne/loginPage/loginPhoto.jpg')",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  arrow: {
    position: "absolute",
    margin: "auto",
    bottom: "20%",
    width: 400,
  },
}));
